import { render, staticRenderFns } from "./mr_widget_missing_branch.vue?vue&type=template&id=bb31c0a2&"
import script from "./mr_widget_missing_branch.vue?vue&type=script&lang=js&"
export * from "./mr_widget_missing_branch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mr_widget_missing_branch.vue"
export default component.exports